
//createAccount landingpage

export const BUSINESSES_TEXT = 'Businesses';  

export const CREATE_ACC_COLOUMNS = [ 
	{ key: 'brandName', label: 'Brand Name', tableOrder: 1 },
	{ key: 'locations', label: 'Locations', tableOrder: 2 },
	{ key: 'createdAt', label: 'Onboarded Date', tableOrder: 3 },
	{ key: 'aggregator', label: 'Aggregator', tableOrder: 4 },
	{ key: 'isAccountCreated', label: 'Account Status', tableOrder: 5 },
	//{ key: 'CreateAccountCTA', label: '', tableOrder: 6}
];

//custom status text

export const USER_ADMIN_CREATED_1 = `Hooray! You've successfully activated access to the 7NOW Merchant Portal for an existing partner. The credentials have been sent to the merchant's email.`;
export const USER_ADMIN_CREATED_2 = `Encourage them to log in soon! A temporary password is included in the email, and just like a special offer, it expires in 7 days.`;
export const USER_ADMIN_CREATED_3 = `Ask them to review the store locations for accuracy in the portal. Accurate details mean accurate insights!`;
export const USER_ADMIN_CREATED_4 = `Let's keep the momentum going and help them make the most of their business with us. Fantastic job setting them up!`;
export const WHATS_NEXT = `What's next?`;
export const DONT_SEE_IT = `Don't see it?`;
export const RESEND_EMAIL = 'Resend email';
export const USER_MERCHANT_CREATED_1 = `Hooray! You've successfully launched another merchant into the 7NOW universe. We've emailed them a temporary password that's good for 7 days, so make sure they log in before it expires—no magic needed, just a timely login!.`;
export const USER_MERCHANT_CREATED_2 = `Connect the POS: Nudge the merchant to log in and sync their Point of Sale system. It's the key to starting their sales journey.`;
export const USER_MERCHANT_CREATED_3 = `Complete Their Setup: Encourage them to finish their profile setup to kick things off on the right foot.`;


////createAccount form 
export const MANAGE_MERCHANTS = 'Manage Merchants';
export const CREATEACCOUNT_TEXT = 'Create Account'; 
export const BUSINESS_TEXT = 'Business Name';  
export const LOCATION_TEXT = 'Location List';
export const VIEW_LOCATION_TEXT = 'View locations';
export const EMAILERR_TEXT = 'Please enter a valid email';  
export const BRANDERR_TEXT  = 'Please select brandname';
export const AGGRERR_TEXT = 'Please select aggregator';
export const USERNAME_TEXT = 'Username'; 
export const USERNAMEERR_TEXT = 'Please enter a valid username'; 
export const BRAND_TEXT = 'Brand Name';
export const AGGREGATOR_TEXT = 'Aggregator'; 
export const PASSWORD_TEXT = 'Password';
export const PASSWORD_SUB_TEXT = 'A temporary password will be configured and sent to the email on file.'; 
export const DETAILS_TEXT = 'Details'; 
export const MERCHANT_MESSAGE = 'What This Form Does'; 
export const MERCHANT_SUB_TEXT = 'This form enables the business development team to set up merchant accounts. Each account grants merchants access to the Merchant Portal, where they can manage and monitor their business metrics.' ;
export const FORM_FOOTER_TEXT = 'What You Need to Do';
export const FORM_FOOTER_SUB_TEXT1 = `Fill in the merchant's business details and email.`;
export const FORM_FOOTER_SUB_TEXT2 = `Assign a username for the merchant's login.`;
export const FORM_FOOTER_SUB_TEXT3 = 'The system automatically selects the aggregator, which you will need to review for accuracy.';						
export const FORM_FOOTER_SUB_TEXT4 = 'Review the store locations associated with the merchant for accuracy by using the hyperlink to open the location list popup.';
export const FORM_FOOTER_SUB_TEXT5 = `Upon submission, a temporary password will be generated and sent to the merchant's email address provided.`;


////Account Confirmation
export const ACCOUNT_CREATED_TEXT = 'Account Created'; 
export const ACCOUNT_CREATED_MESSAGE = 'An account has been successfully created for this business and details have been sent to the email on file.'; 
export const EMAILTEXT = 'Email'; 
export const LOCATIONS_COUNT_TEXT = 'Number of Locations'; 
export const BACKTO_HOME_TEXT = 'Back to Home'; 


////Locations Modal
export const CLOSE_TEXT = 'Close';
export const LOC_TEXT = 'Locations';


//SERVER ERROR
export const FORM_SERVER_ERR = 'An error occurred while trying to create your account. Please return to the activation screen and re-enter credentials.';

//ACC confirmation

export const FORM_SUCCESS_TEXT = `Hooray! You've successfully activated access to the 7NOW Merchant Portal for an existing partner. The credentials have been sent to the merchant's email.`;
export const FORM_SUCCESS_SUBTEXT = `Let's keep the momentum going and help them make the most of their business with us. Fantastic job setting them up!`;

//Adminhomepage

export const HOMEPAGE_TEXT = 'Home'; 
export const HOMEPAGE_CONTENT_HEADER = 'Welcome to the 7NOW Merchant Portal!'; 
export const HOMEPAGE_CONTENT_SUBTEXT1 = 'Welcome to the 7NOW Merchant Portal - Your control hub for everything 7NOW! Each section is crafted to make your workflow effortless, empowering you to create and nurture our merchant relationships.';
export const HOMEPAGE_CONTENT_SUBTEXT1_LINE2 = 'Each section is crafted to make your workflow effortless, empowering you to forge and nurture our merchant relationships.';
export const HOMEPAGE_CONTENT_SUBTEXT2 = `Here's where the magic begins. Details (coming soon).`;
export const HOMEPAGE_CONTENT_SUBTEXT3 = 'Set up new merchant accounts for existing partners, allowing them to activate and manage their business on the 7NOW platform effortlessly.';
export const HOMEPAGE_CONTENT_SUBTEXT4 = 'Create new admin accounts for the Business Development (BD) team.';
export const HOMEPAGE_CONTENT_SUBTEXT5 = 'Manage merchant accounts and monitor their performance.';
export const HOMEPAGE_CONTENT_SUBHEADER1= 'Home';
export const HOMEPAGE_CONTENT_SUBHEADER2= 'Create Accounts';
export const HOMEPAGE_CONTENT_SUBHEADER3= 'Merchant Account'; 
export const HOMEPAGE_CONTENT_SUBHEADER4= 'Admin Account';
export const HOMEPAGE_CONTENT_SUBHEADER5= 'Manage Merchants';
export const HOMEPAGE_CONTENT_LINEITEMHEADING1= 'Merchant Activations:';
export const HOMEPAGE_CONTENT_LINEITEMTEXT1='Create accounts for merchants across different aggregators to activate their locations for the 7NOW Marketplace.';
export const HOMEPAGE_CONTENT_LINEITEMHEADING2='Merchant Reporting:';
export const HOMEPAGE_CONTENT_LINEITEMTEXT2='Merchants can use these accounts to track performance and access reports across the Marketplace for better decision-making and business growth.';

//onboarding-bizdevflow constants  

export const ONBOARD_BUTTON= 'Onboard';
export const VIEWDETIALS_BUTTON= 'View Details';
export const ONBOARD_BUSINESS_TXT= 'Onboard Business';
export const ONBOARDED_TEXT = 'Onboarded';
export const NOT_ONBOARDED_TEXT = 'Not Onboarded';
export const ONBOARDING_COLOUMNS = [
	{ key: 'createdDate', label: 'Date Added', tableOrder: 1 },
	{ key: 'businessLegalName', label: 'Business Entity Name', tableOrder: 2 },
	{ key: 'onboardingStatus', label: 'Status', tableOrder: 3 },
	{ key: 'onboard', label: '', tableOrder: 4 },	
]

//onboarding-statuses related constants

export const MERCHANT_APPROVED_HEADERTXT ='Merchant Approved';
export const MERCHANT_APPROVED_SUBHEADERTXT ='The merchant has been approved for business with 7NOW and a contract has been initiated.';
export const MERCHANT_APPROVED_BTNTXT ='Continue Onboarding Requirements';

export const MERCHANT_NOTAPPROVED_HEADERTXT ='Submission Unsuccessful';
export const MERCHANT_NOTAPPROVED_SUBHEADERTXT ='The merchant has not yet been approved due to a network or API error. Please check your network connection and try again.';
export const MERCHANT_NOTAPPROVED_SUBHEADERTXT2='Please note that clicking on “Back” will take you to the previous page without any saved changes.';
export const MERCHANT_NOTAPPROVED_BTNTXT ='Retry';

export const MERCHANT_CONFIRMED_HEADERTXT ='Merchant Confirmed';
export const MERCHANT_CONFIRMED_SUBHEADERTXT ='The merchant has been confirmed with 7NOW and the contract will need to be signed before account creation. Please note that once the contract is signed, changes can no longer be made to the merchant onboarding details.';
export const MERCHANT_CONFIRMED_BTNTXT ='Contract Signed';

export const MERCHANT_ONBOARDCOMPLETE_HEADERTXT ='Hooray! Onboarding Complete!';
export const MERCHANT_ONBOARDCOMPLETE_SUBHEADERTXT ='The merchant successfully onboarded with 7NOW. You can now create an account for this merchant after confirming their bank details.';
export const MERCHANT_ONBOARDCOMPLETE_BTNTXT ='Return to Onboard Business';

export const MERCHANT_NOTCONFIRMED_HEADERTXT = 'Submission Unsuccessful';
export const MERCHANT_NOTCONFIRMED_SUBHEADERTXT = 'Unable to continue to additional onboarding requirements due to a network or API error. Please check your network connection and try again.';
export const MERCHANT_NOTCONFIRMED_BTNTXT = 'Retry';
